import "./Modal.css";
import "../../page/subpages/index.css";
import { useState ,useContext ,useEffect} from "react";
import NoteContext from "../../context/NoteContext";
//draf-js
import { convertToRaw, EditorState ,convertFromHTML ,ContentState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor  } from "react-draft-wysiwyg";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
//context
import { useTheme } from '../../context/theme-context';
import { useAuth } from "my-webapp/context/login/AuthContext";
//service
import { editNoteService,handle_deleteTrashNote ,handle_updateArchivesNote} from "my-webapp/api/utility";

//modal edit
export const Modal =(props)=>{
    let {token} = useAuth()
    let {handle_editNote,toastdispatch,handle_AddTag,tagList} = useContext(NoteContext)
    const { darkTheme } = useTheme();
    //function
    const [gettext,settext]=useState(props.data.title)
    const [getDesc,setDesc]=useState(props.data.desc)
    const [getcolor,setColor]=useState(props.data.color)
    const [getpin,setPined]=useState(props.data.pin)
    const [getpriority,setpriority]=useState(props.data.priority)
    const [addtag,setaddtag]=useState("")
    const[getlabel,setlabel]=useState("")
    const [getlabelList,setlabelList]=useState(props.data.label)

    //draf
    const blocksFromHtml = htmlToDraft(props.data.desc);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorDataState = EditorState.createWithContent(contentState);
    const [editorState, setEditorState] = useState(editorDataState);
    const[isemty,setempty]=useState(true)

    let note = {
        id:props.data.id,
        title : gettext,
        desc : draftToHtml(convertToRaw(editorState.getCurrentContent())),
        color : getcolor,
        pin :getpin,
        label:getlabelList,
        priority:getpriority,
        date : props.data.date ,
        _id:props.data._id
    }

   
    const wrapperStyle = {
        // border: '1px solid #969696',
        color:'black',
        // background:"rgba(93, 62, 161, 0.3)",
    }

    const toolbarStyle={
        background:'transparent',
        border:"none"
    }

    const editorStyle = {
        height:'5rem',
        padding:'1rem',
        color:'black',
        // background:"rgba(93, 62, 161, 0.3)",
    }

    const onEditorStateChange = (editorStateData) => {
        const content = editorState.getCurrentContent();
        const isEditorEmpty = !content.hasText();
        const currentPlainText = content.getPlainText()
        const lengthOfEditorContent = currentPlainText.length;
        const lengthOfTrimmedContent = currentPlainText.trim().length;
        const isContainOnlySpaces = !isEditorEmpty && !lengthOfTrimmedContent;
    
        if(isEditorEmpty || isContainOnlySpaces){
            
        }else{
            setempty(false)
        }
        setEditorState(editorStateData);
    };

    //
    const handleSubmitAddtag=()=>{
        //e.preventDefault(); 
        if(addtag.trim()!==""){
            let check = tagList.length>0 &&   tagList.find(i=>i.name===addtag.trim())
            if(check){
                alert("name already added")
            }else{
                let data ={
                    id:Math.random(),
                    name:addtag.trim()
                }
                handle_AddTag(data)
                setaddtag("")
            }
        }else{
            alert("text is empty")
        }
    }

    const handleAddTagTextName=(e)=>{
        setaddtag(e.target.value.trim())
    }

    const handleAddLabelList=(e)=>{
        if(e.target.value!==""){
            setlabel(e.target.value)
            let data ={
                id:Math.random(),
                name:e.target.value
            }

            let check = getlabelList.length>0 && getlabelList.find(i=>i.name===e.target.value)
            if(check){
                    alert("already name tag")
            }else{
                    setlabelList(res=>[...res,data]) 
            }   
        }else{
            alert("select tag")
        }   
    }

    const handleOnSubmit=(e)=>{
        e.preventDefault(); 
        if(!isemty){
            editNoteService(token,handle_editNote,note,toastdispatch); 
            props.modalClose()
        }else{
           alert("desc is empty")
        }
    }

    return(
        <div className='modal'>
            <div className="modal-container">  
                <div className='modal-right-side'>
                    <div className='modal-right-flex-row'>
                    
                    <form onSubmit={(e)=>{handleOnSubmit(e)}} className="notes-form" style={{color:darkTheme?"black":"black"}}>
                         <h3> Edit Note</h3>
                         <div className='notes-form-input'>
                            <input type="text" placeholder='title' value={gettext} onChange={(e)=>{settext(e.target.value)}} required/>
                            <div className="modal-draft-editor"> 
                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    wrapperStyle={wrapperStyle}
                                    editorStyle={editorStyle}  
                                    toolbarStyle={toolbarStyle}                                                                         
                                    placeholder='add description'
                                />
                            </div>
                        </div>

                <div className='cn-box-flex'> 
                    <div className='flex-col row-gap-1rem typology-padding-top'> 
                          <div>
                             Set Background Color : 
                            <input type="color" value={getcolor} onChange={(e)=>{setColor(e.target.value)}} required/> 
                          </div>
                          
                          <label> 
                          Set Pined
                                <input type="checkbox" name="pin" value={getpin} checked={getpin===true} onChange={(e)=>{setPined(!getpin)}}/> 
                                
                          </label>
                          <div>
                            <label> Set Priority : </label>
                            <label>
                                <input type="radio" name="Priority" value="High" checked={getpriority==="High"} onChange={(e)=>{setpriority(e.target.value)}} required/>
                                High
                            </label>
                            <label>
                                <input type="radio" name="Priority" value="Medium" checked={getpriority==="Medium"} onChange={(e)=>{setpriority(e.target.value)}} required/> 
                                Medium
                            </label>
                            <label>
                                <input type="radio" name="Priority" value="Low" checked={getpriority==="Low"} onChange={(e)=>{setpriority(e.target.value)}} required/> 
                                Low
                            </label>
                          </div> 
                   </div>
                   <div className='flex-col row-gap-1rem typology-padding-top'>
                          <label> Set Tag : </label>
                          <div>
                               <div>
                                 <input className='input-tag' placeholder='add tag...' value={addtag} onChange={(e)=>{ handleAddTagTextName(e) }}/> 
                                 <span className='button-outline-primary button-onhover-fillbackground cursor' onClick={()=>{handleSubmitAddtag()}}> Add Tag </span>
                               </div>
                              <span> Select tag : </span>
                               {
                                tagList.length>0?
                                      <select value={getlabel} onChange={(e)=>handleAddLabelList(e)}>
                                        <option value="">--tag name list--</option>
                                        {tagList.map((item,index)=>{
                                            return (
                                                <option key={index} value={item.name}> {item.name} </option>
                                            )}
                                        )}
                                      </select> 
                                      :
                                      <span> No tag in list </span>
                               }
                           </div>
                           <div>
                               {getlabelList.length>0?
                               <> 
                                  <label> This Note Tag with: </label>
                                  {
                                   getlabelList.map((item,index)=>{
                                    return(
                                    <div key={index}> 
                                        <label className='tag-name-badge'> {item.name} </label>  
                                        <span className='tag-name-badge-remove cursor' onClick={()=>{setlabelList(getlabelList.filter((_d,_di)=>_di!==index))}}> x </span> 
                                    </div>)
                                  }) 
                                  }  
                               </> 
                               :null}
                           </div>
                    </div>
                 </div>
                 <div className="flex-row col-gap-1rem flex-justify-content-center flex-align-item-center typography-padding-top-right-bottom-left">
                    <button type="submit" className={'button button-outline-primary button-onhover-fillbackground'}> Edit Note </button>
                    <button className='button button-outline-primary button-onhover-fillbackground' onClick={props.modalClose}> Cancel </button>
                </div>
            </form>   
            </div> 
            </div>
            <i className='material-icons modal-close-modal' onClick={props.modalClose}> close </i>
        </div>
    </div> 
    )
}

//modal confirm
export const Modal_Confirm =(props)=>{
    let {handle_deleteTrash,toastdispatch} = useContext(NoteContext)
    let {token} = useAuth()
   return(
    <div className='modal'>
    <div className="modal-container">  
        <div className='modal-right-side'>
            <div className='modal-right-flex-row'>
                <div className="flex-col">
                    <section> Do you want to delete this note permeantly?  </section>
                    <section> 
                        <small>
                            Note: If this note was saved in the archive list, then the note will be deleted only from the note list, not the archive list.
                        </small>
                    </section>
                    <section className="flex-row col-gap-1rem flex-justify-content-center flex-align-item-center">  
                        <button 
                           className="button button-outline-primary button-onhover-fillbackground"
                           onClick={()=>{handle_deleteTrashNote(token,props.data,handle_deleteTrash,toastdispatch);props.modalClose()}}> Yes </button>
                        <button className="button button-outline-primary button-onhover-fillbackground" onClick={props.modalClose}> No </button>
                    </section>
                </div>
            </div> 
        </div>
        <i className='material-icons modal-close-modal' onClick={props.modalClose}> close </i>
    </div>
</div> 
   )
}

//modal archive edit
export const Modal_Archive =(props)=>{
    //context
    let {token} = useAuth()
    let {handle_EditArchive,toastdispatch,handle_AddTag,tagList} = useContext(NoteContext)
    const { darkTheme } = useTheme();
    //state
    const [gettext,settext]=useState(props.data.title)
    const [getDesc,setDesc]=useState(props.data.desc)
    const [getcolor,setColor]=useState(props.data.color)
    const [getpin,setPined]=useState(props.data.pin)
    const [getpriority,setpriority]=useState(props.data.priority)
    const [addtag,setaddtag]=useState("")
    const[getlabel,setlabel]=useState("")
    const [getlabelList,setlabelList]=useState(props.data.label)
    //draf
    const blocksFromHtml = htmlToDraft(props.data.desc);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorDataState = EditorState.createWithContent(contentState);
    const [editorState, setEditorState] = useState(editorDataState);
    const[isemty,setempty]=useState(true)

    //constant
    const update_note = {
        id:props.data.id,
        title : gettext,
        desc : draftToHtml(convertToRaw(editorState.getCurrentContent())),
        color : getcolor,
        pin :getpin,
        label:getlabelList,
        priority:getpriority,
        date : props.data.date ,
        _id:props.data._id
    }
   
      
    const wrapperStyle = {
        // border: '1px solid #969696',
        color:'black',
        // background:"rgba(93, 62, 161, 0.3)",
    }

    const toolbarStyle={
        background:'transparent',
        border:"none"
    }

    const editorStyle = {
        height:'5rem',
        padding:'1rem',
        color:'black',
        // background:"rgba(93, 62, 161, 0.3)",
    }

    //function
    const onEditorStateChange = (editorStateData) => {
        const content = editorState.getCurrentContent();
        const isEditorEmpty = !content.hasText();
        const currentPlainText = content.getPlainText()
        const lengthOfEditorContent = currentPlainText.length;
        const lengthOfTrimmedContent = currentPlainText.trim().length;
        const isContainOnlySpaces = !isEditorEmpty && !lengthOfTrimmedContent;
    
        if(isEditorEmpty || isContainOnlySpaces){
            
        }else{
            setempty(false)
        }
        setEditorState(editorStateData);
    };
    //
    const handleSubmitAddtag=()=>{
        //e.preventDefault(); 
        if(addtag.trim()!==""){
            let check = tagList.length>0 &&   tagList.find(i=>i.name===addtag.trim())
            if(check){
                alert("name already added")
            }else{
                let data ={
                    id:Math.random(),
                    name:addtag.trim()
                }
                handle_AddTag(data)
                setaddtag("")
            }
        }else{
            alert("text is empty")
        }
    }

    const handleAddTagTextName=(e)=>{
        setaddtag(e.target.value.trim())
    }

    const handleAddLabelList=(e)=>{
        if(e.target.value!==""){
            setlabel(e.target.value)
            let data ={
                id:Math.random(),
                name:e.target.value
            }

            let check = getlabelList.length>0 && getlabelList.find(i=>i.name===e.target.value)
            if(check){
                    alert("already name tag")
            }else{
                    setlabelList(res=>[...res,data]) 
            }   
        }else{
            alert("select tag")
        }   
    }

    //

    const handleOnSubmit=(e)=>{
        e.preventDefault(); 
        if(!isemty){
        handle_updateArchivesNote(token,handle_EditArchive,update_note,toastdispatch); 
        props.modalClose()
        }else{
            alert("desc is empty")
        }
    }

    return(
        <div className='modal'>
        <div className="modal-container">  
            <div className='modal-right-side'>
                <div className='modal-right-flex-row'>
                    <form className="notes-form" onSubmit={(e)=>{ handleOnSubmit(e) }} style={{color:darkTheme?"black":"black"}}>
                        <h3> Archive Edit Note</h3>
                        <div className='notes-form-input'>
                            <input type="text" placeholder='title' value={gettext} onChange={(e)=>{settext(e.target.value)}} required/>
                            <div className="modal-draft-editor"> 
                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    wrapperStyle={wrapperStyle}
                                    editorStyle={editorStyle} 
                                    toolbarStyle={toolbarStyle}                                                                          
                                    placeholder='add description'
                                />
                            </div>
                        </div>
                        <div className='cn-box-flex'>
                            <div className='flex-col row-gap-1rem typology-padding-top'> 
                                <div>
                                     Set Background Color :   <input type="color" value={getcolor} onChange={(e)=>{setColor(e.target.value)}} required/>
                                </div>
                                 
                                <label> 
                                      Set pin :
                                        <input type="checkbox" name="pin" value={getpin} checked={getpin===true} onChange={(e)=>{setPined(!getpin)}}/> 
                                        
                                </label>
                                <div>
                                    <label> Set Priority : </label>
                                    <label>
                                        <input type="radio" name="Priority" value="High" checked={getpriority==="High"} onChange={(e)=>{setpriority(e.target.value)}} required/>
                                        High
                                    </label>
                                    <label>
                                        <input type="radio" name="Priority" value="Medium" checked={getpriority==="Medium"} onChange={(e)=>{setpriority(e.target.value)}} required/> 
                                        Medium
                                    </label>
                                    <label>
                                        <input type="radio" name="Priority" value="Low" checked={getpriority==="Low"} onChange={(e)=>{setpriority(e.target.value)}} required/> 
                                        Low
                                    </label>
                                </div>
                          </div>
                          <div className='flex-col row-gap-1rem typology-padding-top'> 
                             <label> Set Tag : </label>
                             <div> 
                               <div>
                                 <input className='input-tag' placeholder='add tag...' value={addtag} onChange={(e)=>{ handleAddTagTextName(e) }}/> 
                                 <span className='button-outline-primary button-onhover-fillbackground cursor' onClick={()=>{handleSubmitAddtag()}}> Add Tag </span>
                               </div>
                              <span> Select tag : </span>
                               {
                                tagList.length>0?
                                      <select value={getlabel} onChange={(e)=>handleAddLabelList(e)}>
                                        <option value="">--tag name list--</option>
                                        {tagList.map((item,index)=>{
                                            return (
                                                    <option key={index} value={item.name}> {item.name} </option>
                                            )}
                                        )}
                                      </select> 
                                      :
                                      <span> No tag in list </span>
                               }
                           </div>
                           <div>
                               {getlabelList.length>0?
                               <> 
                                  <label> This Note Tag with: </label>
                                  {
                                   getlabelList.map((item,index)=>{
                                    return(
                                    <div key={index}> 
                                        <label className='tag-name-badge'> {item.name} </label>  
                                        <span className='tag-name-badge-remove cursor' onClick={()=>{setlabelList(getlabelList.filter((_d,_di)=>_di!==index))}}> x </span> 
                                    </div>)
                                  }) 
                                  }  
                               </> 
                               :null}
                           </div>
                        </div> 
                    </div>
                    <div className="flex-row col-gap-1rem flex-justify-content-center flex-align-item-center typography-padding-top-right-bottom-left">
                    <button type="submit"
                            className='button button-outline-primary button-onhover-fillbackground'
                             
                            > Edit Note 
                    </button>

                    <button className="button button-outline-primary button-onhover-fillbackground" onClick={props.modalClose}> Cancel </button>
                    </div>
                  </form>   
                </div> 
             </div>
            <i className='material-icons modal-close-modal' onClick={props.modalClose}> close </i>
        </div>
    </div> 
    )
}


//modal confirm
export const Modal_EditTag =(props)=>{
    let {handle_EditTag,tagList,toastdispatch} = useContext(NoteContext)
    let {token} = useAuth()
    const [addtag,setaddtag]=useState(props.data.name)
    
    const handleSubmitAddtag=(e)=>{
        e.preventDefault(); 
        if(addtag.trim()!==""){
            let check = tagList.length>0 && tagList.find(i=>i.name===addtag.trim())
            if(check){
                alert("name already added")
            }else{
                let data ={
                    id:props.data.id,
                    name:addtag.trim()
                }
                handle_EditTag(data)
                setaddtag("")
                props.modalClose()
            }
        }else{
            alert("text is empty")
        }
    }

   return(
    <div className='modal'>
    <div className="modal-container">  
        <div className='modal-right-side'>
            <div className='modal-right-flex-row'>
                <div className="flex-col">
                    <section> Edit tag </section>
                    <section> 
                        <form onSubmit={(e)=>{handleSubmitAddtag(e)}}> 
                            <input placeholder='edi tag...' value={addtag} onChange={(e)=>setaddtag(e.target.value)} required/> 
                            <button type='submit' className='button-outline-primary button-onhover-fillbackground'> Edit Tag </button>
                        </form>
                    </section>
                </div>
            </div> 
        </div>
        <i className='material-icons modal-close-modal' onClick={props.modalClose}> close </i>
    </div>
</div> 
   )
}

